import React from 'react'
import {
  BrowserRouter as Router,
  Route,
  Redirect,
} from 'react-router-dom'
import Login from './Login'
import Main from './Main'
import Cookies from 'js-cookie'
import jwt_decode from 'jwt-decode'
import config from '../config'
import { Helmet } from 'react-helmet'

const App = () => {

  const validateToken = () => {
    const token = Cookies.get('token')
    let tokenValid = false
    if (token) {
      const decoded = jwt_decode(token)
      if (Date.now() < decoded.exp * 1000) {
        tokenValid = true
      }
    }
    return tokenValid
  }

  let user = null
  if (Cookies.get('user')) {
    user = JSON.parse(Cookies.get('user'))
  }

  let menu = config.menu
  if (user) {
    if (user.role === 'ROLE_WEBINAR') {
      menu = config.menuWebinar
    } else if (user.role === 'ROLE_STORIES') {
      menu = config.menuStories
    } else if (user.role === 'ROLE_BLOG') {
      menu = config.menuBlog
    }
  }

  return (
    <>
      <Helmet>
        <title>{config.title}</title>
      </Helmet>
      <Router basename="/">
        <Route exact path='/app/*' render={({ location }) => (
          <Redirect to={location.pathname.replace('/app', '')} />
        )} />
        <Route exact path='/' render={({ location }) => {
          return validateToken() ? <Redirect to={`/admin/list/${menu[0].type}`} /> : <Redirect to="/login" />
        }} />
        <Route path='/login' render={({ location }) => {
          return validateToken() ? <Redirect to={`/admin/list/${menu[0].type}`} /> : <Login />
        }} />
        <Route path='/admin' render={({ location }) => {
          return validateToken() ? <Main /> : <Redirect to={{ to: '/', state: { from: location } }} />
        }} />
      </Router>
    </>
  )
}

export default App
